import { render, staticRenderFns } from "./contect.vue?vue&type=template&id=212aa397&"
import script from "./contect.vue?vue&type=script&lang=js&"
export * from "./contect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports